<template>
  <div class="dash-root">
    <AppHeader />

    <v-overlay :value="loading" color="var(--sys-bg)" opacity="0.9">
      <div class="dash-loading">
        <div class="dash-spinner"></div>
        <span>Cargando...</span>
      </div>
    </v-overlay>

    <div class="dash-content">
      <!-- Encabezado de bienvenida -->
      <div class="dash-hero">
        <div class="dash-hero__glow"></div>
        <span class="dash-badge">📊 Panel de Control</span>
        <h1 class="dash-title">Bienvenido, <span class="dash-title--accent">{{ name }}</span></h1>
        <p class="dash-subtitle">Resumen de la procesión seleccionada</p>
      </div>

      <!-- Stat Cards -->
      <div class="stats-grid">
        <!-- Aspirantes -->
        <div class="stat-card">
          <div class="stat-card__icon stat-card__icon--green">
            <v-icon color="white" size="28">mdi-account-group</v-icon>
          </div>
          <div class="stat-card__body">
            <p class="stat-card__label">Aspirantes</p>
            <h2 class="stat-card__value">{{ aspirantes }}</h2>
          </div>
        </div>

        <!-- Cargadores -->
        <div class="stat-card">
          <div class="stat-card__icon stat-card__icon--purple">
            <v-icon color="white" size="28">mdi-account-group</v-icon>
          </div>
          <div class="stat-card__body">
            <p class="stat-card__label">Cargadores</p>
            <h2 class="stat-card__value">{{ cargadores }}</h2>
          </div>
        </div>

        <!-- Honor Salida -->
        <div class="stat-card" v-if="VDD || VDI">
          <div class="stat-card__icon stat-card__icon--purple">
            <v-icon color="white" size="28">mdi-account-star</v-icon>
          </div>
          <div class="stat-card__body">
            <p class="stat-card__label">Honor Salida</p>
            <h2 class="stat-card__value">{{ honor_salida }}</h2>
          </div>
        </div>

        <!-- Honor Entrada -->
        <div class="stat-card" v-if="VDD || VDI">
          <div class="stat-card__icon stat-card__icon--purple">
            <v-icon color="white" size="28">mdi-account-star</v-icon>
          </div>
          <div class="stat-card__body">
            <p class="stat-card__label">Honor Entrada</p>
            <h2 class="stat-card__value">{{ honor_entrada }}</h2>
          </div>
        </div>

        <!-- Honor Extraordinario -->
        <div class="stat-card" v-if="VDI">
          <div class="stat-card__icon stat-card__icon--purple">
            <v-icon color="white" size="28">mdi-star-circle</v-icon>
          </div>
          <div class="stat-card__body">
            <p class="stat-card__label">Honor Extra.</p>
            <h2 class="stat-card__value">{{ honor_extraordinario }}</h2>
          </div>
        </div>

        <!-- Honor Mujeres 1 -->
        <div class="stat-card" v-if="JDC > 0">
          <div class="stat-card__icon stat-card__icon--purple">
            <v-icon color="white" size="28">mdi-human-female</v-icon>
          </div>
          <div class="stat-card__body">
            <p class="stat-card__label">Honor Mujeres 1</p>
            <h2 class="stat-card__value">{{ honor_mujeres1 }}</h2>
          </div>
        </div>

        <!-- Honor Mujeres 2 -->
        <div class="stat-card" v-if="JDC > 0">
          <div class="stat-card__icon stat-card__icon--purple">
            <v-icon color="white" size="28">mdi-human-female</v-icon>
          </div>
          <div class="stat-card__body">
            <p class="stat-card__label">Honor Mujeres 2</p>
            <h2 class="stat-card__value">{{ honor_mujeres2 }}</h2>
          </div>
        </div>

        <!-- Turnos -->
        <div class="stat-card">
          <div class="stat-card__icon stat-card__icon--blue">
            <v-icon color="white" size="28">mdi-swap-vertical</v-icon>
          </div>
          <div class="stat-card__body">
            <p class="stat-card__label">Turnos</p>
            <h2 class="stat-card__value">{{ turnos }}</h2>
          </div>
        </div>

        <!-- Sangrías -->
        <div class="stat-card">
          <div class="stat-card__icon stat-card__icon--orange">
            <v-icon color="white" size="28">mdi-account-multiple</v-icon>
          </div>
          <div class="stat-card__body">
            <p class="stat-card__label">Sangrías</p>
            <h2 class="stat-card__value">{{ sangrias }}</h2>
          </div>
        </div>

        <!-- Recaudación -->
        <div class="stat-card stat-card--wide">
          <div class="stat-card__icon stat-card__icon--yellow">
            <v-icon color="white" size="28">mdi-piggy-bank</v-icon>
          </div>
          <div class="stat-card__body">
            <p class="stat-card__label">Recaudación total</p>
            <h2 class="stat-card__value stat-card__value--lg">{{ recaudacion | moneyFormat }}</h2>
          </div>
        </div>
      </div>

      <!-- Chart -->
      <div class="chart-section">
        <div class="chart-card">
          <h3 class="chart-card__title">Distribución de Participantes</h3>
          <ParticipantesChart v-if="chartDataReady" :chartData="participantesData" />
        </div>
      </div>
    </div>

    <!-- Dialog sesión expirada -->
    <v-dialog v-model="showSessionExpiredDialog" max-width="400">
      <div class="sys-dialog">
        <div class="sys-dialog__header">
          <span class="sys-dialog__title">⏱️ Sesión expirada</span>
        </div>
        <p class="sys-dialog__msg">Tu sesión ha expirado. Por favor, iniciá sesión nuevamente.</p>
        <div class="sys-dialog__actions">
          <button class="sys-btn sys-btn--primary" @click="redirectToLogin">Iniciar sesión →</button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import AppHeader from "@/components/HeaderC.vue";
import ParticipantesChart from "@/components/ParticipantesChart.vue";
import { ref } from "vue";
import axios from "axios";
import { EventBus } from "@/utils/eventBus";

// eslint-disable-next-line no-unused-vars
const variants = ["elevated", "flat", "tonal", "outlined"];
// eslint-disable-next-line no-unused-vars
const color = ref("indigo");

export default {
  name: "DashboardView",
  filters: {
    moneyFormat(value) {
      return "Q. " + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  data: () => ({
    VDD: false,
    JDC: false,
    VDI: false,
    showSessionExpiredDialog: false,
    honor_salida: 0,
    honor_entrada: 0,
    honor_extraordinario: 0,
    honor_mujeres1: 0,
    honor_mujeres2: 0,
    aspirantes: 0,
    cargadores: 0,
    turnos: 0,
    sangrias: 0,
    recaudacion: 0,
    loading: true,
    username: "",
    name: "",
    chartDataReady: false,
    participantesData: {}
  }),
  components: {
    AppHeader,
    ParticipantesChart
  },
  mounted: function () {
    this.initialize();
    EventBus.$on("procesionChanged", () => {
      if (this.$route.path === "/dashboard") {
        this.initialize();
      }
    });
  },
  beforeDestroy() {
    EventBus.$off("procesionChanged", this.initialize);
  },
  methods: {
    async setHermandad() {
      while (!this.$cookies.get("hermandad")) {
        await new Promise((resolve) => setTimeout(resolve, 500));
      }
      const hermandad = this.$cookies.get('hermandad');
      if (hermandad === "Virgen de dolores") {
        this.VDD = true; this.JDC = false; this.VDI = false;
      } else if (hermandad === "Jesús Nazareno de la caída") {
        this.VDD = false; this.JDC = true; this.VDI = false;
      } else if (hermandad === "Hermandad Virgen de dolores Infantil") {
        this.VDI = true; this.VDD = false; this.JDC = false;
      } else if (hermandad === "Hermandad Pruebas") {
        this.VDI = true; this.VDD = true; this.JDC = true;
      } else {
        this.VDI = false; this.VDD = false; this.JDC = false;
      }
    },
    async initialize() {
      await this.setHermandad();
      await this.validateToken();
      await this.obtieneRegistros();
    },
    redirectToLogin() {
      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) { this.$cookies.remove(cookie); }
      this.$router.push("/sistema");
    },
    validateToken() {
      const token = this.$cookies.get("token");
      this.loading = true;
      const apiUrl = `https://wm1xvvtarj.execute-api.us-east-1.amazonaws.com/dev/validateToken?token=${token}`;
      return axios.get(apiUrl)
        .then((response) => {
          const username = response.data.decoded.username;
          const name = response.data.decoded.given_name + " " + response.data.decoded.family_name;
          this.$cookies.set("username", username, "1d", "", "", true, "Strict");
          this.$cookies.set("name", name, "1d", "", "", true, "Strict");
          this.username = username;
          this.name = name;
          this.validToken = true;
        })
        .catch(() => {
          this.validToken = false;
          this.showSessionExpiredDialog = true;
          this.loading = false;
          this.clearAllCookies();
        });
    },
    clearAllCookies() {
      const allCookies = this.$cookies.keys();
      for (const cookie of allCookies) { this.$cookies.remove(cookie); }
    },
    async obtieneRegistros() {
      this.loading = true;
      this.aspirantes = 0; this.cargadores = 0; this.turnos = 0;
      this.sangrias = 0; this.recaudacion = 0;
      while (!this.$cookies.get("ProcesionID")) {
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
      const apiUrl = `https://pc61cf7yyj.execute-api.us-east-1.amazonaws.com/dev/api/dashboard/${this.$cookies.get("ProcesionID")}?usuarioResponsable=${this.$cookies.get("username")}`;
      const token = this.$cookies.get("token");
      const config = { headers: { Authorization: `Bearer ${token}` } };
      try {
        const response = await axios.get(apiUrl, config);
        if (response.data && response.data.records && response.data.records.length > 0) {
          const record = response.data.records[0];
          this.aspirantes = record.aspirantes || 0;
          this.cargadores = record.cargadores || 0;
          this.turnos = record.turnos || 0;
          this.sangrias = record.sangrias || 0;
          this.recaudacion = record.recaudacion || 0;
          this.honor_entrada = record.honor_entrada || 0;
          this.honor_salida = record.honor_salida || 0;
          this.honor_mujeres1 = record.honor_mujeres1 || 0;
          this.honor_mujeres2 = record.honor_mujeres2 || 0;
          this.honor_extraordinario = record.honor_extraordinario || 0;
          this.updateChartData();
        }
      } catch (error) {
        console.error("Error al obtener datos de la API", error);
      } finally {
        this.loading = false;
      }
    },
    updateChartData() {
      const labels = [], values = [], colors = [];
      labels.push("Cargadores"); values.push(this.cargadores); colors.push("#A389F4");
      labels.push("Aspirantes"); values.push(this.aspirantes); colors.push("#6FCF97");
      if (this.VDD || this.VDI) {
        labels.push("Honor Salida"); values.push(this.honor_salida); colors.push("#56CCF2");
        labels.push("Honor Entrada"); values.push(this.honor_entrada); colors.push("#F2C94C");
      }
      if (this.VDI) {
        labels.push("Honor Extra."); values.push(this.honor_extraordinario); colors.push("#F2994A");
      }
      if (this.JDC > 0) {
        labels.push("Honor M1"); values.push(this.honor_mujeres1); colors.push("#EB5757");
        labels.push("Honor M2"); values.push(this.honor_mujeres2); colors.push("#BB6BD9");
      }
      this.participantesData = {
        labels,
        datasets: [{ backgroundColor: colors, borderWidth: 0, data: values }]
      };
      this.chartDataReady = true;
    }
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

.dash-root {
  font-family: 'Inter', sans-serif;
  min-height: 100vh;
  background: var(--sys-bg);
}

/* ── Loading ── */
.dash-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  color: var(--sys-text-secondary);
  font-size: 0.9rem;
}
.dash-spinner {
  width: 36px; height: 36px;
  border: 3px solid rgba(123,47,247,0.3);
  border-top-color: #7b2ff7;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* ── Content ── */
.dash-content {
  max-width: 1300px;
  margin: 0 auto;
  padding: 90px 32px 60px;
}

/* ── Hero ── */
.dash-hero {
  position: relative;
  margin-bottom: 48px;
  padding: 40px 0 20px;
}
.dash-hero__glow {
  position: absolute;
  top: -40px; left: -80px;
  width: 400px; height: 200px;
  background: radial-gradient(ellipse, rgba(123,47,247,0.12) 0%, transparent 70%);
  pointer-events: none;
}
.dash-badge {
  display: inline-block;
  background: rgba(123,47,247,0.15);
  border: 1px solid rgba(123,47,247,0.35);
  color: #c4a0ff;
  padding: 5px 14px;
  border-radius: 100px;
  font-size: 0.78rem;
  font-weight: 600;
  margin-bottom: 16px;
  letter-spacing: 0.03em;
}
.dash-title {
  font-size: clamp(1.8rem, 3vw, 2.6rem);
  font-weight: 800;
  color: var(--sys-text-primary);
  margin-bottom: 8px;
}
.dash-title--accent {
  background: linear-gradient(135deg, #c4a0ff, #7b2ff7);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.dash-subtitle {
  color: var(--sys-text-secondary);
  font-size: 1rem;
}

/* ── Stats Grid ── */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 20px;
  background: var(--sys-card-bg);
  border: 1px solid var(--sys-card-border);
  border-radius: 16px;
  padding: 22px 24px;
  backdrop-filter: blur(12px);
  transition: all 0.3s ease;
  animation: card-in 0.4s ease both;
}
.stat-card:hover {
  transform: translateY(-5px);
  border-color: rgba(123,47,247,0.45);
  box-shadow: 0 12px 40px rgba(123,47,247,0.15);
}
.stat-card--wide {
  grid-column: span 2;
}

@keyframes card-in {
  from { opacity: 0; transform: translateY(16px); }
  to   { opacity: 1; transform: translateY(0); }
}

.stat-card__icon {
  width: 56px; height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.stat-card__icon--green  { background: linear-gradient(135deg, #4ade80, #16a34a); }
.stat-card__icon--purple { background: linear-gradient(135deg, #a78bfa, #7c3aed); }
.stat-card__icon--blue   { background: linear-gradient(135deg, #60a5fa, #2563eb); }
.stat-card__icon--orange { background: linear-gradient(135deg, #fb923c, #c2410c); }
.stat-card__icon--yellow { background: linear-gradient(135deg, #fbbf24, #b45309); }

.stat-card__body {
  flex: 1;
}
.stat-card__label {
  font-size: 0.78rem;
  font-weight: 600;
  color: var(--sys-text-secondary);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 4px;
}
.stat-card__value {
  font-size: 2rem;
  font-weight: 800;
  color: var(--sys-text-primary);
  line-height: 1;
  margin: 0;
}
.stat-card__value--lg {
  font-size: 1.6rem;
}

/* ── Chart ── */
.chart-section {
  margin-top: 12px;
}
.chart-card {
  background: var(--sys-card-bg);
  border: 1px solid var(--sys-card-border);
  border-radius: 20px;
  padding: 32px;
  backdrop-filter: blur(12px);
  max-width: 720px;
  margin: 0 auto;
}
.chart-card__title {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--sys-text-primary);
  margin-bottom: 24px;
  text-align: center;
}

/* ── Dialog ── */
.sys-dialog {
  background: var(--sys-dialog-bg);
  border: 1px solid var(--sys-card-border);
  border-radius: 18px;
  padding: 32px 28px;
  font-family: 'Inter', sans-serif;
}
.sys-dialog__header { margin-bottom: 12px; }
.sys-dialog__title {
  font-size: 1.2rem;
  font-weight: 800;
  color: var(--sys-text-primary);
  display: block;
}
.sys-dialog__msg {
  color: var(--sys-text-secondary);
  font-size: 0.92rem;
  margin: 0 0 24px;
}
.sys-dialog__actions { display: flex; justify-content: flex-end; }

.sys-btn {
  padding: 10px 22px;
  border-radius: 10px;
  font-family: 'Inter', sans-serif;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  border: none;
}
.sys-btn--primary {
  background: linear-gradient(135deg, #7b2ff7, #4a1b9a);
  color: #fff;
  box-shadow: 0 4px 14px rgba(123,47,247,0.35);
}
.sys-btn--primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(123,47,247,0.5);
}

/* ── Responsive ── */
@media (max-width: 768px) {
  .dash-content { padding: 80px 16px 40px; }
  .stats-grid { grid-template-columns: 1fr 1fr; }
  .stat-card--wide { grid-column: span 1; }
}
@media (max-width: 480px) {
  .stats-grid { grid-template-columns: 1fr; }
}
</style>
